<template>
  <el-dialog :title="currentData.id?$t('addOrganDrug.drugDetail'):$t('addOrganDrug.addDrug')"
             :visible.sync="isVisible"
             :close-on-click-modal="false"
             top="6vh"
             width="1000px"
             append-to-body
             @close="isVisible = false">
    <avue-form v-model="formData"
               :option="formOption"
               @submit="handleSubmit">
      <template #diagnoseList>
        <el-tag v-for="(item,index) in formData.diagnoseList"
                :key="item"
                :disable-transitions="false"
                :closable="!currentData.id"
                @close="deleteDiagnose(index)">
          {{ item }}
        </el-tag>
        <el-input v-if="inputVisible"
                  ref="saveTagInput"
                  v-model="diagnoseName"
                  class="input-new-tag"
                  size="small"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm" />
        <el-button v-if="!currentData.id&&!inputVisible"
                   class="button-new-tag"
                   size="small"
                   @click="showInput">+ 添加诊断</el-button>
        <div v-if="currentData.id&&(!formData.diagnoseList||formData.diagnoseList.length==0)">暂无诊断</div>
      </template>
    </avue-form>
  </el-dialog>
</template>

<script>
import { addOrganDrugApi } from '@/commonModule/api/addOrganDrugApi'
import { formOption } from '@/commonModule/assets/addOrganDrug'
import { mapGetters } from 'vuex'

export default {
  name: 'UpdateOrganDrug',
  props: {
    currentData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formOption: formOption(this.currentData.id),
      formData: {},
      isVisible: false,
      isLoading: false,
      inputVisible: false,
      diagnoseName: ''
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
    isVisible(val) {
      if (!val) {
        if (this.$parent.showUpdateOrganDrug) this.$parent.showUpdateOrganDrug = false
        if (this.$parent.$parent.showUpdateOrganDrug) { this.$parent.$parent.showUpdateOrganDrug = false }
      } else {
        this.formData = {
          drugType: this.currentData.drugType == 3 ? 2 : 1,
          diagnoseList: []
        }
        this.fetchDetail()
      }
    }
  },
  methods: {
    async fetchDetail() {
      try {
        if (!this.currentData.id) return
        this.isLoading = true
        const res = await addOrganDrugApi.fetchOrganDrugDetail({
          id: this.currentData.id
        })
        const data = res.data.payload
        data.drugType = data.drugType == 1 ? 1 : data.drugType == 3 ? 2 : ''
        data.diagnoseList = data.diagnose ? data.diagnose.split('；') : []
        setTimeout(() => {
          this.formData = data
          this.isLoading = false
        }, 500)
      } catch (err) {
        console.error(err)
        this.isLoading = false
      }
    },
    deleteDiagnose(index) {
      this.formData.diagnoseList.splice(index, 1)
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm() {
      if (this.diagnoseName) this.formData.diagnoseList.push(this.diagnoseName)
      this.inputVisible = false
      this.diagnoseName = ''
    },
    async handleSubmit(form, done) {
      try {
        const params = {
          ...form,
          drugType: form.drugType == 1 ? 1 : form.drugType == 2 ? 3 : '',
          diagnose: form.diagnoseList.join('；'),
          organId: this.userInfo.company_code || this.userInfo.id
        }
        if (this.$route.query.source === 'store') params.dispensaryUid = this.userInfo.uid
        else {
          params.pharUid = this.userInfo.uid
          params.pharName = this.userInfo.name || ''
        }
        await addOrganDrugApi.createOrganDrug(params)
        done()
        this.$emit('fetchData')
      } catch (err) {
        done()
        console.error(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding-top: 0;
  padding-bottom: 0;
}
/deep/ .el-input.is-disabled .el-input__inner {
  background: none;
  color: #333;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
